// extracted by mini-css-extract-plugin
module.exports = {"image-magnify-wrapper":"ImageMagnify_image-magnify-wrapper__9HjS8"};